<template>
  <div class="general-info">
    <HeadLine>
      {{$ml.get('Irrigation')}}
    </HeadLine>
    <table class="th-table">
      <tr class="head">
        <td>
          {{$ml.get('Stage name')}}
        </td>
        <td>
          {{$ml.get('Total Water Per Stage')}}
        </td>
        <td>
         {{$ml.get('Stage Duration')}}
        </td>
      </tr>

      <tr v-for="n in section['data']['irrigation']">
        <td>
          {{ $ml.get(n.stageName) }}
        </td>
        <td>
          {{ $store.getters['unit/convert']('m3', n.waterPerStage) }} {{$ml.get($store.getters['unit/getLabel']('m3'))}}
        </td>
        <td>
          {{ n.stageDuration }} {{$ml.get('Days')}}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import HeadLine from './../../components/common/HeadLine';
import ValueField from './../../components/common/ValueField';
export default {
  computed: {
    section() {
      return this.$root.data.waterTest;
    }
  },
  components: {
    HeadLine,
    ValueField,
  },
}
</script>

<style lang="scss" scoped>

.general-info {
  .head-line {
    margin-bottom: 10px;
  }

  .th-fields-container {
    margin-bottom: 20px;
  }
}

</style>